<template>
  <v-card>
    <v-container fluid>
      <v-row dense align="end">
        <v-col cols="auto">
          <span
            class="text-h5"
            :class="{ 'gray--text text--lighten-1': medicineDisabled }"
          >
            {{ medicine.name }}
          </span>
        </v-col>

        <v-col cols="auto" v-if="medicineDisabled">
          <span class="text-subtitle-2 gray--text text--lighten-1 mx-2">
            Desabilitado em {{ formattedMedicineDisabledDate }}
          </span>
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <authorization
            permissionKey="configuration_facilitator_medicine"
            can="save"
            v-slot:default="{ authorization }"
          >
            <v-dialog
              v-if="!medicineDisabled"
              v-model="dialog"
              max-width="500px"
              @click:outside="close"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-if="authorization"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  eva-edit-outline
                </v-icon>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">Editar medicamento</span>
                </v-card-title>

                <v-card-text>
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="medicine.name"
                          label="Nome"
                          :hide-details="!errors.medicine"
                          :error-messages="errors.medicine"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="save">
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </authorization>

          <authorization
            permissionKey="configuration_facilitator_medicine"
            can="delete"
            v-slot:default="{ authorization }"
          >
            <v-tooltip top>
              <template
                v-slot:activator="{ on: tooltipListeners, attrs: tooltipAttrs }"
              >
                <v-icon
                  v-if="authorization"
                  v-on="tooltipListeners"
                  v-bind="tooltipAttrs"
                  @click="toggleMedicineEnabled"
                >
                  {{ toggleMedicineIconName }}
                </v-icon>
              </template>
              <span v-if="medicineDisabled">Habilitar</span>
              <span v-else>Desabilitar</span>
            </v-tooltip>
          </authorization>
        </v-col>
      </v-row>

      <v-divider />

      <v-row dense>
        <v-col>
          <ApplicationRouteTable
            :medicine="medicine"
            :refreshList="refreshList"
            :disabled="medicineDisabled"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import ApplicationRouteTable from "@/components/config/medicine/medicine/item/application_route_table.vue";

  const CONFIRM_MEDICINE_ENABLE_MESSAGE =
    "Tem certeza de que deseja habilitar este medicamento?";
  const CONFIRM_MEDICINE_DISABLE_MESSAGE =
    "Tem certeza de que deseja desabilitar este medicamento?";

  export default {
    name: "MedicineListItem",
    props: {
      medicine: Object,
      refreshList: Function,
    },
    components: {
      ApplicationRouteTable,
    },
    data() {
      return {
        errors: {},
        dialog: null,
      };
    },
    computed: {
      toggleMedicineIconName() {
        return this.medicineDisabled ? "eva-unlock-outline" : "eva-lock-outline";
      },
      medicineDisabled() {
        return this.medicine.disabled;
      },
      formattedMedicineDisabledDate() {
        const disabledAt = this.medicine.disabledAt;

        if (!disabledAt) return "";

        return this.$moment(disabledAt).format("DD/MM/YYYY à\\s HH:mm");
      },
    },
    methods: {
      async toggleMedicineEnabled() {
        if (!this.confirmToggleMedicineEnabled()) return;

        const newDisabledStatus = !this.medicineDisabled;

        await this.apolloMutate({
          mutation: require("@/graphql/medicine/save_medicine_disabled_status.gql"),
          variables: {
            medicineId: this.medicine.id,
            disabled: newDisabledStatus,
          },
        });

        this.refreshList();

        const newStatusText = newDisabledStatus ? "desabilitado" : "habilitado";

        this.$store.dispatch("createNotification", {
          message: `Medicamento ${newStatusText} com sucesso.`,
          type: "success",
        });
      },
      close() {
        this.dialog = false;
      },
      save() {
        if (!this.validate()) return;

        this.apolloMutate({
          mutation: require("@/graphql/medicine/save_medicine.gql"),
          variables: {
            medicineId: this.medicine.id,
            name: this.medicine.name,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        let name = this.medicine.name;
        if (this.lodash.isEmpty(name?.trim())) {
          this.errors.medicine = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
      confirmToggleMedicineEnabled() {
        const message = this.medicineDisabled
          ? CONFIRM_MEDICINE_ENABLE_MESSAGE
          : CONFIRM_MEDICINE_DISABLE_MESSAGE;

        return confirm(message);
      },
    },
  };
</script>

<style lang="sass" scoped></style>
